import React from 'react';
import styles from './HighlightedVoucher.module.scss';

interface HighlightedVoucherProps {
  voucher: any;
}

const HighlightedVoucher: React.FC<HighlightedVoucherProps> = ({ voucher }) => {
  const goToSection = () => {
    console.log('Navigate to section');
  };

  return (
    <div className={styles.voucher}>
      <p>icon 50% OFF for all products in Mugs Category</p>
      <p>Code: TOTEBAGUK | Ends on 30/10</p>
      <hr />
      <div className={styles.thumbnails}>
        <img src="" alt="" className={styles.productThumbnail} />
        <img src="" alt="" className={styles.productThumbnail} />
        <img src="" alt="" className={styles.productThumbnail} />
        <img src="" alt="" className={styles.productThumbnail} />
      </div>
      <br />
      <button onClick={goToSection}>Select products ArrowIcon</button>
    </div>
  );
};

export default HighlightedVoucher;
